import { render } from "./PaymentDetails.vue?vue&type=template&id=47b1cda2&scoped=true"
import script from "./PaymentDetails.vue?vue&type=script&lang=js"
export * from "./PaymentDetails.vue?vue&type=script&lang=js"

import "./PaymentDetails.vue?vue&type=style&index=0&id=47b1cda2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b1cda2"]])

export default __exports__